import { usePrevious } from '@radix-ui/react-use-previous';
import { useEffect } from 'react';
import { useCallbackRef } from '@radix-ui/react-use-callback-ref';
import usePresence from './presence/usePresence.mjs';

const usePopperPresence = ({
  open,
  onPresenceChange: _onPresenceChange
}) => {
  const { isPresent, ref } = usePresence(open);
  const previousOpen = usePrevious(open);
  const isOpenToClose = previousOpen && !open;
  const onPresenceChange = useCallbackRef(_onPresenceChange);
  useEffect(() => {
    if (isPresent) {
      onPresenceChange?.(true);
    }
  }, [isPresent, onPresenceChange]);
  useEffect(() => {
    if (isOpenToClose && !isPresent) {
      onPresenceChange?.(false);
    }
  }, [isOpenToClose, isPresent, onPresenceChange]);
  return { ref };
};

export { usePopperPresence as default };
//# sourceMappingURL=usePopperPresence.mjs.map
